import { BASE_URL, CALCULATOR_BASE_URL, CRM_API_URL } from "./baseURL";
import { get, post } from "./api";

export const getCalculatorData = (payload) => {
  return new Promise(async (resolve, reject) => {
    const { universityMind, plan, inflation, university } = payload;
    try {
      const res = await get(
        `${CALCULATOR_BASE_URL}university?Country=${university}&PlanTerm=${plan}&InflationRate=${inflation}&University=${universityMind}`
      );
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const getCoverageCalculatorData = (payload) => {
  return new Promise(async (resolve, reject) => {
    const { amount, currency, age, numberOfYears } = payload;
    try {
      const res = await get(
        `${CALCULATOR_BASE_URL}coverage?AnnualIncome=${amount}&Currency=${currency}&Age=${age}&NumberOfYears=${numberOfYears}`
      );
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};


export const actionButtons = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/plan-type-config` +
        `?populate[plan_step_sec][populate][content]=true` +
        `&populate[plan_step_sec][populate][actions]=true` +
        `&populate[plan_step_sec][populate][steps][populate][icon]=true` +
        `&populate[faq_sec_info]=true` +
        `&populate[hero_action]=true` +
        `&populate[plan_actions]=true` +
        `&populate[faq_sub_sec_question]=true` +
        `&populate[faq_actions]=true` +
        `&populate[bottom_banner][populate][banner][populate][img]=true` +
        `&populate[bottom_banner][populate][content]=true` +
        `&populate[bottom_banner][populate][action]=true`
      );
      resolve(res?.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const planDetails = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/plans?filters[slug][$eq]=${payload}` +
        `&populate[banner][populate][img]=true` +
        `&populate[banner][populate][arabic_img]=true` +
        `&populate[seo_meta]=true` +
        `&populate[key_feat][populate][icon]=true` +
        `&populate[content]=true` +
        `&populate[faqs][populate][question]=true` +
        `&populate[faqs][populate][answer]=true` +
        `&populate[plan_step_sec][populate][actions]=true` +
        `&populate[plan_step_sec][populate][steps][populate][icon]=true` +
        `&populate[plan_step_sec][populate][content]=true`
      );
      resolve(res?.data);
    } catch (err) {
      reject(err);
    }
  });

}

export const planDetailsConfig = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/plan-config?populate=*`
      );
      resolve(res?.data);
    } catch (err) {
      reject(err);
    }
  });

}

export const getSocialLinks = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/utils?populate[social_icon][populate][social_img]=true`
      );
      resolve(res?.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const getPlansProtection = (payload) => {

  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/plan-types` +
        `?filters[slug][$eq]=${payload}` +
        `&populate[banner][populate][img]=true` +
        `&populate[banner][populate][arabic_img]=true` +
        `&populate[seo_meta]=true` +
        `&populate[content]=true` +
        `&populate[plans][populate][banner][populate][img]=true` +
        `&populate[plans][populate][content]=true` +
        `&populate[plans][populate][key_feat][populate][icon]=true` +
        `&populate[plans][populate][listing_titles]=true` +
        `&populate[faqs][populate][question]=true` +
        `&populate[faqs][populate][answer]=true`
      );

      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const getPageNotFound = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/not-found?populate[0]=notfound&populate[1]=background.img&populate[2]=seo_meta`
      );
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};


export const getHeaderRoutes = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/plan-types?sort=order` +
        `&populate[content]=true` +
        `&populate[plans][populate][content]=true` +
        `&populate[header_menu_icon][populate][img]=true`
      );
      resolve(res?.data);
    } catch (err) {
      reject(err);
    }
  });
}

export const getSpeakToAdvisor = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/speak-to-advisor?
populate[title]=true
&populate[name]=true
&populate[email]=true
&populate[number]=true
&populate[submitbutton]=true
&populate[thanks][populate][icon]=true
&populate[thanksbutton]=true
`
      );
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};
export const setCRMLead = (payload) => {
  const fullName = payload.name ? payload.name.trim() : '';
  const nameParts = fullName.split(' ');

  const FirstName = nameParts.length > 0 ? nameParts[0] : '';
  const LastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
  const copPayload = {
    "FirstName": FirstName,
    "LastName": LastName,
    "CPR": payload.CPR ? payload.CPR : '',
    "PhoneNumber": payload.mobile ? payload.mobile : '',
    "subject": payload.subject || "",
    "Product": "LIFE",
    "Email": payload.email ? payload.email : '',
    "customerType": 1,
    "status": 1,
    "productType": payload.productType || "",
    "stage": "",
    "lead_id": "",
    "Quote": "",
    "channel": "online.solidarity",
    "LOBProduct": payload.LOBProduct || ""
  }
  return new Promise(async (resolve, reject) => {
    try {
      const res = await post(CRM_API_URL, copPayload);
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const getMenuDropdowns = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/parent-menus?sort=order` +
        `&populate[label]=true` +
        `&populate[menu_groups][populate][menu_group][populate][icon][populate][img]=true` +
        `&populate[menu_groups][populate][menu_group][populate][menu][populate][icon]=true`
      );
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};
